import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["button", "content"]

  connect () {
    this.disableAllActive()
    this.buttonTargets[0].classList.add('active')
    this.contentTargets[0].classList.add('active')
  }

  disableAllActive () {
     this.buttonTargets.forEach((button) => {
      button.classList.remove("active")
    })

    this.contentTargets.forEach((content) => {
      content.classList.remove("active")
    })
  }

  toggleActive (event) {
    event.preventDefault()
    event.stopPropagation()

    this.buttonTargets.forEach((button) => {
      button.classList.toggle("active", event.currentTarget.dataset.tabName === button.dataset.tabName)
    })

    this.contentTargets.forEach((content) => {
      content.classList.toggle("active", event.currentTarget.dataset.tabName === content.dataset.tabName)
    })
  }
}
